module.exports = __webpack_public_path__ + "img/logo.b72b1e2a.png";